/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.moderation.cancelScheduledActions'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  subjects: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    maxLength: 100,
  }),
  comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<CancellationResults>((() => cancellationResults) as any),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Cancel all pending scheduled moderation actions for specified subjects */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type CancellationResults = {
  $type?: 'tools.ozone.moderation.cancelScheduledActions#cancellationResults'

  /**
   * DIDs for which all pending scheduled actions were successfully cancelled
   */
  succeeded: l.DidString[]

  /**
   * DIDs for which cancellation failed with error details
   */
  failed: FailedCancellation[]
}

export type { CancellationResults }

const cancellationResults = /*#__PURE__*/ l.typedObject<CancellationResults>(
  $nsid,
  'cancellationResults',
  /*#__PURE__*/ l.object({
    succeeded: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
    failed: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<FailedCancellation>(
        (() => failedCancellation) as any,
      ),
    ),
  }),
)

export { cancellationResults }

type FailedCancellation = {
  $type?: 'tools.ozone.moderation.cancelScheduledActions#failedCancellation'
  did: l.DidString
  error: string
  errorCode?: string
}

export type { FailedCancellation }

const failedCancellation = /*#__PURE__*/ l.typedObject<FailedCancellation>(
  $nsid,
  'failedCancellation',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    error: /*#__PURE__*/ l.string(),
    errorCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { failedCancellation }
